import React from "react";
import GetText from "../../i18n/GetText";
import { PageMetadata } from "../../model/metadata";
import Link from "../Link/Link";
import LanguageMenu from "./LanguageMenu";
import styles from "./MinorNav.module.scss";
import Text from "../Text/Text";

interface MinorNavProps {
  metadata: PageMetadata;
}

const MinorNav = ({ metadata }: MinorNavProps) => {
  return (
    <ul className={styles.subHeader}>
      <li>
        <LanguageMenu
          buttonClassName={styles.link}
          alternates={metadata.alternates}
        />
      </li>
      <li>
        <Link to="https://support.microbit.org" className={styles.link}>
          <Text variant="defaultLight" as="span">
            <GetText id="help-and-support" fallback="Help & support" />
          </Text>
        </Link>
      </li>
      <li>
        <Link to="/get-started/user-guide/safety/" className={styles.link}>
          <Text variant="defaultLight" as="span">
            <GetText id="safety" fallback="Safety" />
          </Text>
        </Link>
      </li>
    </ul>
  );
};

export default MinorNav;
